export default "__VITE_ASSET__COBcweQB__"